{
    "tenants": {
        "title": "Locataires",
		"addTenant": "Ajouter un locataire",
		"companyName": "Nom de l'entreprise",
		"tenantAlias": "Alias du locataire",
		"email": "E-mail",
		"tier": "Niveau",
		"status": "Statut",
		"type": "Type",
		"address": "Adresse",
		"phone": "Téléphone",
		"adminEmail": "E-mail administrateur",
		"billingEmail": "E-mail facturation",
		"tenantType": "Type de locataire",
		"tenantApps": "Applications du locataire",
		"tenantLabel": "Locataire",
		"smsMfa": "SMS MFA",
		"newTenant": "Nouveau locataire",
		"editTenant": "Modifier le locataire",
        "active": "Actif",
		"inactive": "Inactif",
		"enabled": "Activé",
		"disabled": "Désactivé",
        "tenantUsers": "Utilisateurs du locataire",
        "validation": {
            "companyNameRequired": "Nom de l'entreprise obligatoire",
            "addressRequired": "Adresse obligatoire",
            "addressMaxLength": "L'adresse ne doit pas dépasser 100 caractères",
            "phoneRequired": "Téléphone obligatoire",
            "phoneInvalid": "Veuillez entrer un numéro de téléphone valide",
            "adminEmailRequired": "Email administrateur obligatoire",
            "adminEmailInvalid": "Veuillez saisir une adresse e-mail valide pour l'administrateur",
            "billingEmailInvalid": "Veuillez saisir une adresse e-mail valide pour la facturation",
            "billingEmailRequired": "E-mail de facturation obligatoire",
			"tierRequired": "Niveau obligatoire",
			"tenantTypeRequired": "Type de locataire obligatoire",
			"dedicatedIpHostnameRequired": "Le nom d'hôte est obligatoire lorsque l'IP dédiée est activée",
			"dedicatedIpHostnameInvalid": "Veuillez entrer un nom d'hôte valide (ex. eu-west-dedicated-02.quotaguard.com)",
			"dedicatedIpEgressIpRequired": "L'IP de sortie est obligatoire lorsque l'IP dédiée est activée",
			"dedicatedIpEgressIpInvalid": "Veuillez entrer une adresse IPv4 valide (ex. 192.168.1.1)",
			"dedicatedIpUsernameRequired": "Le nom d'utilisateur est obligatoire lorsque l'IP dédiée est activée",
			"dedicatedIpPasswordRequired": "Le mot de passe est obligatoire lorsque l'IP dédiée est activée",
			"dedicatedIpPortRequired": "Le port est obligatoire lorsque l'IP dédiée est activée",
			"dedicatedIpPortInvalid": "Veuillez entrer un numéro de port valide (1–65535)",
			"dedicatedIpProtocolRequired": "Le protocole est obligatoire",
			"dedicatedIpProtocolDuplicate": "Le protocole doit être unique pour chaque port"
        },
		"options": {
			"manageTenant": "Gérer le locataire",
			"manageTenantUsers": "Gérer les utilisateurs du locataire",
			"promoteToAdmin": "Promouvoir en tant qu'administrateur Live",
			"adminRoleNoActions": "Rôle administrateur — aucune action disponible",
			"reindexEntities": "Ré-indexer les entités"
		},
		"messages": {
            "loadError": "Erreur lors du chargement des données du locataire",
			"deactivateTenantConfirmation": "Êtes-vous sûr de vouloir désactiver le locataire '{tenantName}' ?",
			"statusUpdateSuccess": "Statut du locataire mis à jour avec succès",
			"statusUpdateError": "Erreur lors de la mise à jour du statut du locataire",
			"saveSuccess": "Les détails du locataire sont en cours d'enregistrement. Cela peut prendre un moment…",
			"saveError": "Erreur lors de l'enregistrement des détails du locataire",
			"tenantUserGroupUpdated": "Groupe d'utilisateurs mis à jour avec succès",
			"tenantUserGroupUpdateError": "Erreur lors de la mise à jour du groupe d'utilisateurs",
            "confirmPromoteToAdmin": "Êtes-vous sûr de vouloir promouvoir {user} en tant qu'administrateur ?",
			"reindexSuccess": "Ré-indexation lancée pour {count} entités",
			"reindexError": "Erreur lors du lancement de la ré-indexation"
		},
		"reindex": {
			"title": "Ré-indexer les entités",
			"description": "Sélectionnez un type d'entité à ré-indexer pour le locataire '{tenantName}'.",
			"selectEntity": "Sélectionnez une entité",
			"confirm": "Ré-indexer"
		},
		"dedicatedIp": {
			"title": "IPs dédiées",
			"enable": "Utiliser une IP dédiée",
			"proxyHostname": "Nom d'hôte du proxy",
			"port": "Port",
			"listeningPorts": "Ports d'écoute",
			"selectService": "Sélectionner un protocole",
			"username": "Nom d'utilisateur",
			"usernamePlaceholder": "proxy-username",
			"password": "Mot de passe",
			"passwordPlaceholder": "••••••••",
			"passwordSet": "Mot de passe défini ✓",
			"passwordChangePlaceholder": "Laisser vide pour conserver le mot de passe existant",
			"egressIp1": "IP de sortie 1",
			"egressIp2": "IP de sortie 2"
		},
		"tenantTypes": {
			"SYSADMIN": "Administration en direct",
			"TENANT": "Administrateur des locataires"
		},
		"tiers": {
			"FREE": "Gratuit",
			"ENTERPRISE": "Entreprise",
			"PRO": "Pro"
		},
		"resource": {
			"tenant": "Locataire"
		}
    }
}
